interface AvatarProps {
  name: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  imageUrl?: string | null
}

const SIZE_CLASS: Record<NonNullable<AvatarProps['size']>, string> = {
  sm: 'avatar-sm',
  md: '',
  lg: 'avatar-lg',
  xl: 'avatar-xl',
}

export function Avatar({ name, size = 'md', imageUrl }: AvatarProps) {
  const initial = name.trim().charAt(0).toUpperCase() || '?'
  const sizeClass = SIZE_CLASS[size]

  if (imageUrl) {
    return (
      <span className={`avatar avatar-rounded ${sizeClass}`.trim()}>
        <img src={imageUrl} alt={name} />
      </span>
    )
  }

  return (
    <span className={`avatar avatar-rounded bg-primary-transparent ${sizeClass}`.trim()}>
      {initial}
    </span>
  )
}
